























import { Component, Prop, Vue } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { ActivationModel, ServiceActivationModel } from '@/app/shared/models';
import ContentService from '@/app/shared/components/contents/service.vue';
@Component({ components: { ContentService } })
export default class PanelServiceComponent extends Vue {
  @Prop(Object) readonly data!: ActivationModel;

  private activation: ActivationModel = new ActivationModel();
  private listServiceActivation: ServiceActivationModel[] = [];
  private loading = false;
  private show = false;

  private get refs() {
    return refsService;
  }

  private async openContent() {
    if (this.show) this.show = false;
    else {
      this.loading = true;
      await Promise.allSettled([
        this.refs.services.policy
          .getActivationById(this.refs.modules.policy.policy.Id, this.data.Id)
          .then((res) => (this.activation = res)),
        this.refs.services.policy
          .getListServiceActivationById(
            this.refs.modules.policy.policy.Id,
            this.data.Id
          )
          .then((res) => (this.listServiceActivation = res)),
      ])
        .then(() => (this.show = true))
        .catch((err) => this.$toast.error('ERROR ? ', err))
        .finally(() => (this.loading = false));
    }
  }
}
